import get from "lodash/get"
import map from "lodash/map"
import isEmpty from "lodash/isEmpty"
import classNames from "classnames"
import { wmFonts, wmColor } from "themes-lib/wmTheme"
import { ReactSVG } from "react-svg"
import { makeStyles } from "tss-react/mui"
import getContentUrl from "utils-lib/getContentUrl"
import { useState, useEffect } from "react"
import { withAuthentication } from "hoc-lib/appAuthentication"
import { withLocalization } from "hoc-lib/localization"
import { MULTI_NAVIGATION_TABS_ITEMS } from "constants-lib/dashboardNavigationTabs"
import withRouter from "hoc-lib/router"
import { BOOTSTRAP_GRID_IPAD_PRO_MAX } from "constants-lib/dimensions"
import { getWindow } from "utils-lib/getWindow"
import { isMyWMApp } from "utils-lib/isMyWMApp"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { Configure, InstantSearch } from "react-instantsearch"
import { searchClient } from "constants-lib/algoliaSearchClient"
import { handleEnterPress } from "utils-lib/handleEnterPress"
import Popover from "component-lib/Base/components/Popover"
import Box from "component-lib/Base/components/Box"
import Tooltip from "component-lib/Base/components/Tooltip"
import { Link, Button, ButtonTextIcon } from "../../../Base"
import CustomAutoCompleteMobile from "../../../Algolia/CustomAutoCompleteMobile/CustomAutoCompleteMobile"
import LanguageDropdown from "../TopHeader/components/LanguageDropdown/LanguageDropdownContainer"
import SupportDropdown from "../TopHeader/components/SupportDropdown/SupportDropdownContainer"
import MobileRedesignedHeader from "./components/MobileRedesignedHeader/MobileRedesignedHeader"
import RedesignedHeaderNavItems from "./components/RedesignedHeaderNavItems/RedesignedHeaderNavItems"
import GlobalNotifications from "../GlobalNotifications/GlobalNotificationsContainer"
import ProfileMenuModal from "./components/ProfileMenuModal/ProfileMenuModalContainer"

const useStyles = makeStyles()(
  (theme, { isDashboardTabSelected, isGlobalNotificationClosed }) => ({
    pageWrapper: {
      height: !isGlobalNotificationClosed ? "110px" : "60px",
    },
    headerContainer: {
      backgroundColor: "white",
      boxShadow:
        "0 2px 6px 0 rgba(175, 181, 186, 0.3), 0 -1px 6px 0 rgba(175, 181, 186, 0.3)",
      display: "flex",
      justifyContent: "center",
    },
    headerPadding: {
      paddingLeft: "7.75rem",
      paddingRight: "12.25rem",
      [theme.breakpoints.down(1500)]: {
        paddingLeft: "5rem",
        paddingRight: "5rem",
      },
    },
    buttonText: {
      color: `${theme.palette.primary.main2_0} !important`,
      fontWeight: 900,
    },
    headerWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "100%",
      width: "100%",
      maxWidth: "1620px",
      padding: "0 20px",
    },
    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
    },
    menuWrapper: {
      display: "flex",
      alignItems: "center",
      height: "60px",
    },
    menuIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "26px",
      "& > svg": {
        height: 15,
        width: 20,
      },
      "& g": {
        stroke: wmColor.green1,
      },
    },
    headerLinksWrapper: {
      display: "flex",
      width: "30%",
      "& > button": {
        color: `${theme.palette.text.secondary} !important`,
        height: "60px !important",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderBottom: "",
        ...wmFonts.maaxBold,
        "&:hover": {
          borderBottom: `3px solid ${theme.palette.text.secondary} !important`,
        },
      },
    },
    dashboardTab: {
      borderBottom: isDashboardTabSelected ? `3px solid black !important` : ``,
      "&:focus": {
        outline: `2px auto -webkit-focus-ring-color !important`,
      },
    },
    billingTab: {
      borderBottom: !isDashboardTabSelected ? `3px solid black !important` : ``,
      "&:focus": {
        outline: `2px auto -webkit-focus-ring-color !important`,
      },
    },
    supportLink: {
      color: `${theme.palette.text.secondary} !important`,
      ...wmFonts.maaxBold,
      height: `50px`,
      textDecoration: "none !important",
    },
    headerRight: {
      display: "flex",
      alignItems: "center",
    },
    headerRightFirstPart: {
      display: "flex",
      alignItems: "center",
      gap: "30px",
      marginRight: "30px",
    },
    headerRightSecondPart: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    counter: {
      width: "12px",
      height: "12px",
      position: "relative",
      left: "0.625rem",
      bottom: "1.650rem",
      backgroundColor: wmColor.green6,
      borderRadius: "50%",
      fontSize: "9px",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ...wmFonts.maaxBold,
    },

    cartButton: {
      position: "relative",
      padding: "0px",
    },
    cartIcon: {
      display: "flex",
      alignItems: "center",
      "&>svg": {
        height: `26px`,
        marginTop: `10px`,
      },
    },
    profileLink: {
      display: "flex",
      padding: 0,
      alignItems: "center",
      height: "40px",
      border: `2px solid ${wmColor.green1}!important`,
      borderRadius: "19px",
      "&:hover": {
        backgroundColor: `${wmColor.greenTint} !important`,
      },
    },
    userIcon: {
      display: "flex",
      alignItems: "center",
      marginLeft: `12px`,
      marginRight: `10px`,
      "&>svg": {
        height: `30px`,
        width: `30px`,
      },
    },
    iconWrapper: {
      padding: "0px",
    },
    svgIcon: {
      display: "flex",
      alignItems: "center",
      height: `50px`,
      "&>svg": {
        height: `26px`,
        width: `28px`,
        "&>circle": {
          fill: wmColor.redAlertCircle,
        },
      },
    },
    firstName: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      color: wmColor.green1,
      paddingRight: "12px",
      ...wmFonts.maaxRegular,
    },
    searchContainer: {
      width: "375px",
    },
    back: {
      "& svg": {
        transform: `rotate(180deg)`,
        "& path, polyline": {
          stroke: wmColor.green2,
        },
      },
    },
    tooltip: {
      background: `#fff`,
      boxShadow:
        "0 2px 6px 0 rgba(175, 181, 186, 0.3), 0 -1px 6px 0 rgba(175, 181, 186, 0.3)",
      borderRadius: "10px",
      color: wmColor.gray4,
      fontSize: `12px`,
      ...wmFonts.maaxBold,
      padding: "10px 16px 16px 16px",
      border: `1px solid ${wmColor.gray3}`,
      margin: "0px 12px",
      lineHeight: `1rem`,
    },
    arrow: {
      color: wmColor.white,
      left: `30px !important`,
      "&:before": {
        border: `1px solid ${wmColor.gray3}`,
      },
    },
    notificationArrow: {
      color: wmColor.white,
      left: `39px !important`,
      "&:before": {
        border: `1px solid ${wmColor.gray3}`,
      },
    },
    notificationArrowFrench: {
      color: wmColor.white,
      left: `18px !important`,
      "&:before": {
        border: `1px solid ${wmColor.gray3}`,
      },
    },
    needHelpWrapper: {
      "& > button": {
        color: `${theme.palette.text.secondary} !important`,
      },
    },
  }),
)

export const strings = {
  en_CA: {
    DASHBOARD: `Dashboard`,
    BILLING: `Billing`,
    SERVICES: `Services`,
    NOTIFICATIONS: `Notifications`,
    SUPPORT: `Support`,
    NEED_HELP: `Need Help?`,
    CART: `Cart`,
    SEARCH: `Search`,
    MY_SUPPORT_REQUESTS: `My Support Requests`,
  },
  fr_CA: {
    DASHBOARD: `Tableau de bord`,
    BILLING: `Facturation`,
    SERVICES: `Services`,
    NOTIFICATIONS: `Avis`,
    SUPPORT: `Soutien`,
    NEED_HELP: `Besoin d’aide?`,
    CART: `Panier`,
    SEARCH: `Search`,
    MY_SUPPORT_REQUESTS: `My Support Requests`,
  },
}

export const RedesignedHeader = ({
  navigationDetails,
  siteLanguage,
  getCartDetails,
  ecommerceCart = {},
  logo,
  logoLink,
  setParentState,
  setShowMobileSearch,
  showMobileSearch,
  logoAltText,
  isSupportSearch,
  indexList,
  suggestionIndex,
  queryIndex,
  numResults,
  numHighlightedResults,
  numberQueries,
  numCharacters,
  errorMessageTitle,
  errorMessageDescription,
  failureTitle,
  failureDescription,
  suggestedText,
  resultsText,
  seeAllResultsText,
  searchDelay,
  resultsIndex,
  searchPlaceholder,
  firstName,
  emailId,
  mobilePhone,
  selectedAccountDetails,
  isPopoverOpen,
  togglePopover,
  languages,
  router,
  hasNotification,
  onMenuClick,
  isMenuOpen,
  strings,
  alerts,
  onAlertsChange,
  onAlertClose,
  isSingleAccount,
  setIsCustomerSelectClicked,
  setNewMultiAccountTabSelected,
  multiAccountDashboard,
}) => {
  const [search, setSearch] = useState(``)
  const [profileMenuOpen, setProfileMenuOpen] = useState(false)

  useEffect(() => {
    setShowMobileSearch(false)
  }, [])
  const isDashboardTabSelected =
    multiAccountDashboard?.multiAccountDashboardTabSelected ===
    MULTI_NAVIGATION_TABS_ITEMS[0].string

  const ssrWindow = getWindow()

  const isGlobalNotificationClosed = JSON.parse(
    ssrWindow.localStorage.getItem("closeAll"),
  )

  const { classes } = useStyles({
    isDashboardTabSelected,
    isGlobalNotificationClosed,
  })

  useEffect(() => {
    if (isEmpty(multiAccountDashboard?.multiAccountDashboardTabSelected)) {
      setNewMultiAccountTabSelected?.(MULTI_NAVIGATION_TABS_ITEMS[0].string)
    }
  }, [])

  const onCartClick = () => {
    getCartDetails().then((url) => {
      if (url) {
        ssrWindow.location = url
      }
    })
  }

  const US_EN_ROUTE = `/us/en`

  const languageRoute = getLanguageRoute(siteLanguage.language)

  let supportLinks = [
    {
      label: strings.SUPPORT,
      url: `${languageRoute}/support`,
      isExternalLink: true,
    },
  ]
  if (languageRoute === US_EN_ROUTE) {
    supportLinks = [
      ...supportLinks,
      {
        label: strings.MY_SUPPORT_REQUESTS,
        url: `${languageRoute}/mywm/user/my-support-requests`,
        isExternalLink: true,
      },
    ]
  }

  const isMobile = ssrWindow.innerWidth <= BOOTSTRAP_GRID_IPAD_PRO_MAX

  const damPath = getContentUrl(`/content/dam/wm/icons`)

  const newDashboardDamPath = getContentUrl(
    `/content/dam/wm/icons/single-use/dashboard`,
  )

  const renderCart = () => {
    const numberOfProducts = get(ecommerceCart, `count`, ``)

    return (
      numberOfProducts && (
        <Button className={classes.cartButton} onClick={onCartClick}>
          <ReactSVG
            wrapper="span"
            className={classes.cartIcon}
            src={`${newDashboardDamPath}/cart.svg`}
            key="cart-icon-header"
          />
          <span className={classes.counter}>{numberOfProducts}</span>
        </Button>
      )
    )
  }

  const renderSearch = () => (
    <>
      <Box className={classes.searchContainer}>
        <Button
          fontClass="maax-font-weight-regular d-flex align-items-center"
          overrideClass={`px-3 my-2 pl-4 ${classes.back}`}
          onClick={() => {
            setShowMobileSearch(false)
          }}
          ariaLabel="Back"
        >
          <ReactSVG
            wrapper="span"
            title="back"
            src={getContentUrl(`/content/dam/mywm/icons/arrow-right.svg`)}
          />
        </Button>
      </Box>
      <form
        className="flex-grow-1"
        onSubmit={(e) => {
          e.preventDefault()

          ssrWindow.location = `${languageRoute}/search?q=${encodeURIComponent(
            search,
          )}`
        }}
      >
        <InstantSearch
          searchClient={searchClient}
          indexName={resultsIndex}
          future={{ preserveSharedStateOnUnmount: false }}
          insights
        >
          <CustomAutoCompleteMobile
            isSupportSearch={isSupportSearch}
            search={search}
            setSearch={setSearch}
            resultsIndex={resultsIndex}
            suggestionIndex={suggestionIndex}
            queryIndex={queryIndex}
            searchPlaceholder={searchPlaceholder}
            numResults={numResults}
            numHighlightedResults={numHighlightedResults}
            numberQueries={numberQueries}
            numCharacters={numCharacters}
            errorMessageTitle={errorMessageTitle}
            errorMessageDescription={errorMessageDescription}
            failureTitle={failureTitle}
            failureDescription={failureDescription}
            onClose={() => {
              setShowMobileSearch(false)
            }}
            suggestedText={suggestedText}
            resultsText={resultsText}
            seeAllResultsText={seeAllResultsText}
            language={siteLanguage.language}
            indexList={indexList}
            searchDelay={searchDelay}
            isNewDashboard
          />
          <Configure analyticsTags={["header"]} />
        </InstantSearch>
      </form>
    </>
  )

  const renderNavigationTabs = () => {
    const languageRoute = getLanguageRoute(siteLanguage.language)
    const dashBoardUrl =
      ssrWindow.location.href.endsWith(`/mywm/user/dashboard`)
    const multiTabsItems =
      dashBoardUrl && !isSingleAccount ? [] : MULTI_NAVIGATION_TABS_ITEMS
    return map(multiTabsItems, (item) => (
      <Box key={item.string} className={classes.headerLinksWrapper}>
        <Button
          fontClass={classes.headerButton}
          onClick={() => {
            setNewMultiAccountTabSelected(item.string)
            const isAccountsDashboardPage =
              ssrWindow?.location?.pathname?.includes("user/account-dashboard")
            if (!isAccountsDashboardPage) {
              const url = `${languageRoute}/mywm/user/account-dashboard`
              isMyWMApp ? router.push(url) : (ssrWindow.location = url)
            }
          }}
          className="has-focus"
        >
          {strings[item.string]}
        </Button>
      </Box>
    ))
  }

  const renderAlertButton = () => (
    <Tooltip
      title={strings.NOTIFICATIONS}
      placement="bottom"
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow:
          siteLanguage.language === `fr_CA`
            ? classes.notificationArrowFrench
            : classes.notificationArrow,
      }}
    >
      <Button
        ariaLabel={
          hasNotification
            ? "Notifications: Unread notifications"
            : "Notifications: No new notifications"
        }
        className={classNames(classes.iconWrapper, "has-focus")}
        onClick={() => {
          if (isTeamsitePage(ssrWindow.location.pathname) || !isMyWMApp) {
            ssrWindow.location.pathname = `${languageRoute}/mywm/user/notifications`
          } else {
            router.push(`${languageRoute}/mywm/user/notifications`)
          }
        }}
        type="button"
      >
        <ReactSVG
          className={classes.svgIcon}
          src={
            hasNotification
              ? `${newDashboardDamPath}/bell-notification.svg`
              : `${newDashboardDamPath}/bell-v2.svg`
          }
        />
      </Button>
    </Tooltip>
  )

  const renderProfileButton = () =>
    firstName ? (
      <Button
        overrideClass={classes.profileLink}
        onClick={() => {
          setProfileMenuOpen(true)
        }}
      >
        <ReactSVG
          wrapper="span"
          className={classes.userIcon}
          src={`${newDashboardDamPath}/account.svg`}
          aria-hidden="true"
        />
        <span className={classes.firstName}>
          {firstName.length > 9 ? `${firstName.slice(0, 9)}...` : firstName}
        </span>
      </Button>
    ) : (
      <Button
        onClick={() => {
          setProfileMenuOpen(true)
        }}
        className={classes.iconWrapper}
      >
        <ReactSVG
          wrapper="span"
          src={`${newDashboardDamPath}/account.svg`}
          className={classes.svgIcon}
          aria-hidden="true"
        />
      </Button>
    )

  return isMobile ? (
    <MobileRedesignedHeader
      navigationDetails={navigationDetails}
      getCartDetails={getCartDetails}
      ecommerceCart={ecommerceCart}
      onMenuClick={onMenuClick}
      isMenuOpen={isMenuOpen}
      logo={logo}
      logoLink={logoLink}
      logoAltText={logoAltText}
      siteLanguage={siteLanguage}
      setParentState={setParentState}
      setShowMobileSearch={setShowMobileSearch}
      showMobileSearch={showMobileSearch}
      isSupportSearch={isSupportSearch}
      indexList={indexList}
      suggestionIndex={suggestionIndex}
      resultsIndex={resultsIndex}
      queryIndex={queryIndex}
      numResults={numResults}
      numHighlightedResults={numHighlightedResults}
      numberQueries={numberQueries}
      numCharacters={numCharacters}
      errorMessageTitle={errorMessageTitle}
      errorMessageDescription={errorMessageDescription}
      failureTitle={failureTitle}
      failureDescription={failureDescription}
      suggestedText={suggestedText}
      resultsText={resultsText}
      seeAllResultsText={seeAllResultsText}
      searchDelay={searchDelay}
      hasNotification={hasNotification}
      onCartClick={onCartClick}
      alerts={alerts}
      onAlertsChange={onAlertsChange}
      onAlertClose={onAlertClose}
      {...{
        setIsCustomerSelectClicked,
        setNewMultiAccountTabSelected,
        multiAccountDashboard,
        isSingleAccount,
        firstName,
        emailId,
        mobilePhone,
        selectedAccountDetails,
      }}
    />
  ) : (
    <Box className={classes.pageWrapper} data-testid="RedesignedHeader">
      <Box
        className={`Header  ${classes.headerContainer}  ${classes.headerPadding}`}
      >
        <GlobalNotifications
          alerts={alerts}
          onAlertsChange={onAlertsChange}
          onAlertClose={onAlertClose}
          isRedesignedWMHeader
        />
        <Box className={classes.headerWrapper}>
          <Box className={classes.headerLeft}>
            <ButtonTextIcon
              className={`Header__menu-button ${classes.menuWrapper}`}
              ariaLabel={isMenuOpen ? "Close main menu" : "Open main menu"}
              onClick={() => {
                togglePopover(true)
              }}
              onKeyPress={(e) => {
                e.stopPropagation()
                handleEnterPress(togglePopover(true))
              }}
            >
              <Box
                onClick={() => togglePopover(!isPopoverOpen)}
                className={classes.menuIcon}
              >
                <span>
                  {isPopoverOpen ? (
                    <ReactSVG
                      wrapper="span"
                      src={`${damPath}/green-close-x-icon.svg`}
                    />
                  ) : (
                    <ReactSVG
                      wrapper="span"
                      src={`${damPath}/green-hamburger-menu-icon.svg`}
                    />
                  )}
                </span>
              </Box>
            </ButtonTextIcon>
            <Popover
              className={classes.searchContainer}
              disableScrollLock
              aria-expanded={isPopoverOpen}
              anchorEl={ssrWindow.document.querySelector(
                `.Header__menu-button`,
              )}
              anchorOrigin={{
                vertical: `bottom`,
                horizontal: `left`,
              }}
              transformOrigin={{
                vertical: `top`,
                horizontal: `left`,
              }}
              open={isPopoverOpen}
              onClose={(e) => {
                if (isPopoverOpen) {
                  e.stopPropagation()
                  togglePopover(false)
                  setShowMobileSearch(false)
                }
              }}
              PaperProps={{
                style: {
                  maxHeight: "85vh",
                },
              }}
            >
              {showMobileSearch ? (
                renderSearch()
              ) : (
                <RedesignedHeaderNavItems
                  navigationDetails={navigationDetails}
                  togglePopover={() => {
                    togglePopover(false)
                  }}
                  onMenuClick={onMenuClick}
                  setParentState={setParentState}
                  searchPlaceholder={strings.SEARCH}
                  setIsSearchOpen={setShowMobileSearch}
                />
              )}
            </Popover>
            <Link
              className="position-relative has-focus"
              href={`${logoLink}`}
              isExternalLink
            >
              <ReactSVG
                wrapper="span"
                className="footer-logo"
                src={getContentUrl(logo)}
                alt={logoAltText}
              />
            </Link>
            {renderNavigationTabs()}
          </Box>
          <Box className={classes.headerRight}>
            <Box className={classes.headerRightFirstPart}>
              <Box className={classes.needHelpWrapper}>
                <SupportDropdown
                  showCaret
                  label={strings.NEED_HELP}
                  links={supportLinks}
                />
              </Box>
              <Box className="d-flex align-items-center">
                <LanguageDropdown languages={languages} />
              </Box>
            </Box>
            <Box className={classes.headerRightSecondPart}>
              {renderCart()}
              {renderAlertButton()}
              {renderProfileButton()}
            </Box>
          </Box>
        </Box>
      </Box>
      {profileMenuOpen && (
        <ProfileMenuModal
          firstName={firstName}
          emailId={emailId}
          mobilePhone={mobilePhone}
          selectedAccountDetails={selectedAccountDetails}
          profileMenuOpen={profileMenuOpen}
          setProfileMenuOpen={setProfileMenuOpen}
          siteLanguage={siteLanguage}
        />
      )}
    </Box>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// RedesignedHeaderLegacy.propTypes = {
//   navigationDetails: PropTypes.array.isRequired,
//   siteLanguage: PropTypes.object.isRequired,
//   getCartDetails: PropTypes.func.isRequired,
//   ecommerceCart: PropTypes.object,
//   logo: PropTypes.string.isRequired,
//   logoLink: PropTypes.string.isRequired,
//   // this is an unused prop, removed from the migrated component
//   // language: PropTypes.string.isRequired,
//   setParentState: PropTypes.func.isRequired,
//   setShowMobileSearch: PropTypes.func.isRequired,
//   showMobileSearch: PropTypes.bool.isRequired,
//   logoAltText: PropTypes.string.isRequired,
//   isSupportSearch: PropTypes.bool.isRequired,
//   indexList: PropTypes.array.isRequired,
//   suggestionIndex: PropTypes.string.isRequired,
//   queryIndex: PropTypes.string.isRequired,
//   numResults: PropTypes.number.isRequired,
//   numHighlightedResults: PropTypes.number.isRequired,
//   numberQueries: PropTypes.number.isRequired,
//   numCharacters: PropTypes.number.isRequired,
//   errorMessageTitle: PropTypes.string.isRequired,
//   errorMessageDescription: PropTypes.string.isRequired,
//   failureTitle: PropTypes.string.isRequired,
//   failureDescription: PropTypes.string.isRequired,
//   suggestedText: PropTypes.string.isRequired,
//   resultsText: PropTypes.string.isRequired,
//   seeAllResultsText: PropTypes.string.isRequired,
//   searchDelay: PropTypes.number.isRequired,
//   resultsIndex: PropTypes.string.isRequired,
//   searchPlaceholder: PropTypes.string.isRequired,
//   firstName: PropTypes.string.isRequired,
//   isPopoverOpen: PropTypes.bool.isRequired,
//   togglePopover: PropTypes.func.isRequired,
//   languages: PropTypes.array.isRequired,
//   router: PropTypes.object.isRequired,
//   hasNotification: PropTypes.bool.isRequired,
//   onMenuClick: PropTypes.func.isRequired,
//   isMenuOpen: PropTypes.bool.isRequired,
//   strings: PropTypes.object.isRequired,
//   alerts: PropTypes.array.isRequired,
//   onAlertsChange: PropTypes.func.isRequired,
//   onAlertClose: PropTypes.func.isRequired,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// RedesignedHeaderLegacy.defaultProps = {
//   ecommerceCart: {},
// }

export default withLocalization(strings)(
  withAuthentication(withRouter(RedesignedHeader)),
)
